
export function removeAccents(string) {

    const accents = "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
    const accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";

    return string
        .split("")
        .map((letter, index) => {
            const accentIndex = accents.indexOf(letter);
            return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
        })
        .join("");
}

export function checkRequiredFields(object, requiredFields = []) {
    requiredFields.forEach(function (field) {
        if (!object.hasOwnProperty(field)) {
            throw new Error('Field "' + field + '" does not exist in object');
        }
    });
}